<!--  Publisher (3) has disbable to delete user -->
<template>
  <div>
    <div style="display:flex;justify-content:space-between;align-item:center;">
      <el-button type="primary"
                 @click="$router.push('/admin/create')">Create Author</el-button>
      <el-form :inline="true"
               @submit.native.prevent="searchUser">
        <el-form-item style="margin:0 0 0 5px">
          <el-input v-model="searchText"
                    placeholder="Search" @keyup.enter.native="searchUser">


                    
          </el-input>

        </el-form-item>
          <el-form-item style="margin:0 0 0 5px">


          Filter By:
          <el-select
              v-model="activevalue"
              style="width:170px"
              clearable
              placeholder="Select"
            >
              <el-option
                v-for="item in activevalues"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>


          </el-form-item>
          <el-form-item style="margin:0 0 0 5px">

            <el-button icon="el-icon-search"
                       @click="searchUser"></el-button>
         

 
        </el-form-item>






      </el-form>

    </div>
    <hr>
    <div style="display:flex; justify-content:flex-end; align-items:center;">
      <div class="user-info">Activated {{totalUsers - inactiveUsers}}</div>
      <div class="user-info">Inactive {{inactiveUsers}}</div>
      <div class="user-info">Total {{totalUsers}}</div>
      <div>
        <el-pagination v-if="!isSearchMode"
                       :background="true"
                       layout="prev, pager, next"
                       :current-page.sync="currentPage"
                       :page-size="10"
                       :total="totalUsers"
                       @current-change="handlePageChange()">
        </el-pagination>
      </div>
    </div>
    <el-table :data="userDatas"
              v-loading="loading"
              empty-text="No Data"
              style="width: 100%;">
      <el-table-column label="AVATAR"
                       width="80"
                       align="center">
        <template slot-scope="scope">
          <img :src="scope.row.avatar"
               alt="avatar"
               style="width:50px;">
        </template>
      </el-table-column>
      <el-table-column prop="book_name"
                       label="BOOK COVER NAME"></el-table-column>
      <el-table-column prop="income_name"
                       label="INCOME TAX NAME"></el-table-column>
      <!-- <el-table-column prop="biography"
                       label="Biography"></el-table-column> -->
      <el-table-column prop="tags"
                       label="INFO"
                       width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.role === 1 ? 'primary' : 'success'"
                  size="mini"
                  disable-transitions>{{scope.row.role === 1 ? 'Admin' : 'User'}}</el-tag>
          <el-tag v-if="scope.row.active===0"
                  type="warning"
                  size="mini"
                  disable-transitions>Inactive</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right"
                       label="OPERATIONS"
                       width="120">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click.native.prevent="viewUserProfile(userDatas[scope.$index])">
            View</el-button>
          <el-button v-if="userRole === 1"
                     @click="handleDelete(userDatas[scope.$index].id)"
                     type="text"
                     size="small">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="!isSearchMode"
                   :background="true"
                   layout="total, prev, pager, next"
                   :current-page.sync="currentPage"
                   :page-size="10"
                   :total="totalUsers"
                   :page-count="totalUsers"
                   @current-change="handlePageChange()">
    </el-pagination>
  </div>

</template>

<script>
import AuthHelper from '../../utils/auth.js';
export default {
  created() {
    // Get user pages will emit change of the pagination
    // So it needs to record the currentPage
    this.currentPage = Number.isInteger(+this.$route.params.page)
      ? +this.$route.params.page
      : 1;
    this.countAllUsers();
    this.getInactiveUsers();
    this.getUsers(this.currentPage);
  },
  data() {
    return {
      isSearchMode: false,
      userDatas: [],
      totalUsers: 0,
      currentPage: 0,
      loading: false,
      searchText: '',
      inactiveUsers: 0,
      userRole: AuthHelper.getRole(),
      activevalue : 1,
      activevalues : [
      // {
      //     value:'',
      //     label:'none'
      //   },
      {
          value:1,
          label:'Active Authors'
        },
        {
          value:0,
          label:'Inactive Authors'
        },

      ],
      // sortorder : 'asc',
      // sortorders : [
      // {
      //     value:'asc',
      //     label:'A-Z'
      //   },
      //   {
      //     value:'desc',
      //     label:'Z-A'
      //   },

      // ],
    };
  },
  watch: {
    $route(to, from) {
      if (Number.isInteger(+to.params.page)) this.getUsers(to.params.page);
    },
  },
  methods: {
    getUsers(numOfPage) {
      this.loading = true;
      this.axios({
        method: 'get',
        url: `/users?page=${numOfPage}`,
      })
        .then(res => {
          if (res.data.success) {
            this.userDatas = res.data.results;
            this.loading = false;
          }
        })
        .catch(err => {});
    },
    countAllUsers() {
      this.axios({
        method: 'get',
        url: '/users/pages',
      })
        .then(res => {
          this.totalUsers = res.data.count;
        })
        .catch(err => {});
    },
    getInactiveUsers() {
      this.axios({
        method: 'get',
        url: '/users/inactive',
      })
        .then(res => {
          this.inactiveUsers = res.data.count;
        })
        .catch(err => {});
    },
    handlePageChange() {
      this.$router.push('/admin/list/' + this.currentPage);
      localStorage.page = this.currentPage;
    },
    viewUserProfile(user) {
      localStorage.userName = user.book_name;
      this.$router.push(`/admin/${user.id}/profile`);
    },
    handleDelete(userID) {
      this.$confirm('Are you sure want to delete this user?', 'info', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(() => {
          this.axios({
            method: 'delete',
            url: `/user/${userID}`,
          })
            .then(res => {
              this.userDatas = this.userDatas.filter(
                user => user.id !== userID
              );
              this.$message({
                type: 'success',
                message: 'User delete!',
              });
            })
            .catch(err => {
              this.$message({
                type: 'error',
              });
            });
        })
        .catch(() => {});
    },
    searchUser() {
      this.loading = true;
      this.axios({
        method: 'get',
        url: '/users/search',
        params: {
          text: this.searchText,
          activevalue: this.activevalue,
        },
      })
        .then(res => {
          this.isSearchMode = true;
          this.userDatas = res.data;
          this.loading = false;
        })
        .catch(err => {});
    },
    clearSearch() {
      this.isSearchMode = false;
      this.searchText = '';
      this.getUsers(this.currentPage);
    },
  },
};
</script>
<style lang="scss" scoped>
.input-with-select {
  width: 33%;

  .el-select .el-input {
    width: 110px;
  }
}
.el-pagination {
  text-align: right;
}

.user-info {
  color: #606266;
  font-size: 13px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/UserList.vue